// components/store/ProductRow.js
// Fila de productos del ecommerce que se muestra arriba del feed de notas en las
// páginas de categoría (perfumería, data, teatro).
//
// Sólo aparece si, para esa categoría, la tienda está habilitada en el admin Y
// hay al menos un producto visible. Mientras carga no renderiza nada, para que
// el HTML pre-renderizado y el primer render del cliente coincidan (sin saltos
// ni errores de hidratación).

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProductRow.css';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

function formatPrice(p) {
  const n = new Intl.NumberFormat('es-AR').format(p.price);
  return p.currency === 'USD' ? `USD ${n}` : `$${n}`;
}

const ProductRow = ({ category }) => {
  const [store, setStore] = useState({ enabled: false, title: 'Tienda', products: [] });

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND}/api/store/${category}`)
      .then(r => r.json())
      .then(data => { if (!cancelled && data) setStore(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [category]);

  // No mostrar nada si la tienda está oculta o no hay productos visibles
  if (!store.enabled || !store.products || store.products.length === 0) return null;

  return (
    <section className="store-row">
      <h2 className="store-row-title">{store.title}</h2>
      <div className="store-row-track">
        {store.products.map(p => (
          <Link key={p.id} to={`/producto/${p.slug}`} className="store-card">
            <div className="store-card-img-wrap">
              {p.is_new && <span className="store-card-badge">NUEVO</span>}
              {p.main_image
                ? <img src={p.main_image} alt={p.name} className="store-card-img" loading="lazy" />
                : <div className="store-card-img store-card-img-empty" />}
            </div>
            <div className="store-card-body">
              <h3 className="store-card-name">{p.name}</h3>
              <div className="store-card-meta">
                <span className="store-card-price">{formatPrice(p)}</span>
                {p.stock <= 0 && <span className="store-card-out">Agotado</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ProductRow;
